import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useMemo, useState } from "react";
import "./layout.css";
import maisLogo from "./assets/mais_logo.png";

export default function Layout() {
  const navigate = useNavigate();

  const [openProduction, setOpenProduction] = useState(false);
  const [openCrush, setOpenCrush] = useState(false);
  const [openMaster, setOpenMaster] = useState(false);

  const currentUser = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      return null;
    }
  }, []);

  const username = currentUser?.username || "User";

  const linkClass = ({ isActive }) =>
    `sidebar-link ${isActive ? "active" : ""}`;

  function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  }

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-left">
          <img src={maisLogo} alt="Mais Logo" className="header-logo" />
        </div>

        <div className="header-center">
          <div className="company-title">
            Saudi Mais Co. For Irrigation Systems
          </div>
          <div className="company-subtitle">Production System</div>
        </div>

        <div className="header-right">
          <div className="header-user-card">
            <span className="header-user-name">{username}</span>
          </div>

          <button
            type="button"
            className="header-logout-btn"
            onClick={logout}
          >
            Logout
          </button>
        </div>
      </header>

      <div className="app-body">
        <aside className="app-sidebar">
          <NavLink className={linkClass} to="/" end>
            <span className="menu-icon">•</span>
            Home
          </NavLink>

          <button
            className="sidebar-section"
            onClick={() => setOpenProduction(!openProduction)}
          >
            <span>Production</span>
            <span className="chev">{openProduction ? "▾" : "▸"}</span>
          </button>

          {openProduction && (
            <div className="sidebar-links">
              <NavLink className={linkClass} to="extruder">
                <span className="menu-icon">•</span>
                Extruder
              </NavLink>

              <NavLink className={linkClass} to="injection">
                <span className="menu-icon">•</span>
                Injection
              </NavLink>
            </div>
          )}

          <button
            className="sidebar-section mt-space"
            onClick={() => setOpenCrush(!openCrush)}
          >
            <span>Crush & Recycling</span>
            <span className="chev">{openCrush ? "▾" : "▸"}</span>
          </button>

          {openCrush && (
            <div className="sidebar-links">
              <NavLink className={linkClass} to="crush-1">
                <span className="menu-icon">•</span>
                Crush 1
              </NavLink>

              <NavLink className={linkClass} to="crush-2">
                <span className="menu-icon">•</span>
                Crush 2
              </NavLink>

              <NavLink className={linkClass} to="recycling">
                <span className="menu-icon">•</span>
                Recycling
              </NavLink>

              <NavLink className={linkClass} to="reports/crush-recycling">
                <span className="menu-icon">•</span>
                Report
              </NavLink>
            </div>
          )}

          <button
            className="sidebar-section mt-space"
            onClick={() => setOpenMaster(!openMaster)}
          >
            <span>Masters</span>
            <span className="chev">{openMaster ? "▾" : "▸"}</span>
          </button>

          {openMaster && (
            <div className="sidebar-links">
              <NavLink className={linkClass} to="item-master">
                <span className="menu-icon">•</span>
                Item Master
              </NavLink>
            </div>
          )}
        </aside>

        <main className="app-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}